import React, { useEffect } from 'react'
import styles from './MerchantPc.module.scss'
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import ValueSection from './components/ValueSection'
import CooperationRequirements from './components/CooperationRequirements'
import CooperationProcess from './components/CooperationProcess'
import CooperationAgents from './components/CooperationAgents'
import Footer from './components/Footer'
import { isProd } from '@/utils/utils'
import CustomButton from '@common/components/CustomButton'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'
import { useDeviceType } from '@/common/hoc/getDeviceType'

const MerchantPc: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])
  const deviceType = useDeviceType()
  
  useEffect(() => {
    if (deviceType === 'mobile') {
      window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/agentH5.html' : 'https://osm.51ping.com/os/h5/seek-investment/agentH5.html', '_blank'
    }
  }, [deviceType])

  const openJoin = () => {
    // 打开新的窗口，跳转到入驻页面
    window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/agentJoin.html' : 'https://osm.51ping.com/os/h5/seek-investment/agentJoin.html'
  }


  return (
    <div className={styles.pcContainer}>
      <Header onJoin={openJoin} />

      <main>
        <HeroSection onJoin={openJoin} />
        <ValueSection />
        <CooperationRequirements />
        <CooperationProcess />
        <CooperationAgents />
      </main>

      <Footer />

      <div className={styles.fixedBar}>
        <CustomButton variant='primary' className={styles.fixedBtn} onClick={openJoin}>
          {t('wantToJoin', "立即合作")}
        </CustomButton>
      </div>
    </div>
  )
}

const MerchantPcWithTranslator = withTranslator(MerchantPc)
export default MerchantPcWithTranslator